import * as React from 'react';

import ParameterFieldBase, { IParameterFieldBaseOptions } from '../ts/ParameterFieldBase';
import CKEditField, { ICKEditFieldPropsBase, ICKEditFieldPropsBaseOptions } from './CKEditField';
import { IGlob } from '../../application/ts/Glob';

declare var require: any;
require('../sass/ckedit-popup-field.sass');

interface ICKEditPopupFieldProps extends ICKEditFieldPropsBase<string> {
    hidePreview: boolean;
}

interface ICKEditPopupComponentState {
    value;
}

export class CKEditPopupComponent extends React.Component<ICKEditPopupFieldProps, ICKEditPopupComponentState> {
    constructor(props: ICKEditPopupFieldProps) {
        super(props);

        this.state = {
            value: props.value
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return {
                value: nextProps.value
            };
        } else {
            return null;
        }
    }

    private handleEdit = () => {
        let editorConfig = this.props.editorConfig;

        if (editorConfig == null && this.props.options != null) {
            editorConfig = this.props.options.editorConfig;
        }

        let dependencies = this.props.dependencies;

        if (dependencies == null && this.props.options != null) {
            dependencies = this.props.options.dependencies;
        }

        this.props.glob.DialogActions.createDialog(
            'Edit Document',
            null,
            (obj) => {
                this.setValue(obj);
            },
            function () {},
            function () {},
            'custom',
            {
                deny: false,
                confirmTitle: 'OK',
                Component: CKEditDialog,
                componentOptions: {
                    data: this.state.value,
                    editorConfig: editorConfig || {},
                    dependencies: dependencies || null
                }
            }
        );
    };

    private setValue = (val) => {
        this.setState({ value: val });

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(val);
        }
    };

    render() {
        var preview;

        if (this.props.hidePreview) {
            var lines = this.state.value.split('\n');
            preview = <span title={this.state.value}>{(lines[0] || '') + ' ... '}</span>;
        } else {
            preview = <div className="preview" dangerouslySetInnerHTML={{ __html: this.state.value }} />;
        }
        return (
            <div className="ckedit-popup-field">
                <button className="btn btn-default edit-button" onClick={this.handleEdit}>
                    {'Edit'}
                </button>

                {preview}
            </div>
        );
    }
}

interface ICKEditDialogOptions extends ICKEditFieldPropsBaseOptions {
    data?;
}

class CKEditDialog extends React.Component<
    {
        setConfirmValueGetter(getConfirmValue);
        unsetConfirmValueGetter?();

        glob: IGlob;
        options: ICKEditDialogOptions;
    },
    {
        data;
    }
> {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.options.data
        };
    }

    private getConfirmValue = () => {
        return this.state.data;
    };

    componentWillMount() {
        var obj = this.props.setConfirmValueGetter(this.getConfirmValue);
    }

    componentWillUnmount() {
        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    private handleDataChange = (val) => {
        this.setState({
            data: val
        });
    };

    render() {
        return (
            <div className="w-100 h-100">
                <CKEditField
                    // { ...this.props }
                    options={this.props.options}
                    fillContainer={true}
                    value={this.state.data}
                    glob={this.props.glob}
                    onChange={this.handleDataChange}
                />
            </div>
        );
    }
}

export default class CKEditPopupField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = CKEditPopupComponent;

    constructor(glob, title: string, validators?: any, defaultVal: string = '', options?) {
        super(glob, title, CKEditPopupField.defaultValidators, validators, defaultVal, options);
    }
}
